import { useMemo } from "react";
import { useGetAdvertsQuery } from "@services/adverts/queries";
import { useBannerMessagesQuery } from "@services/messages/queries";
import { useCurrentLanguageCode } from "@utils/common";
import { JointBillAdvert } from "./components/JointBillAdvert/JointBillAdvert";

export const JointBillAdverts: React.FC = () => {
  const currentLanguageCode = useCurrentLanguageCode();
  const { data: advertsData } = useGetAdvertsQuery(currentLanguageCode);

  const { data: bannerMessages } = useBannerMessagesQuery();

  const availableAdverts = useMemo(() => {
    const bannerTypes = bannerMessages?.map((banner) => banner.bannerType);

    return advertsData?.filter(
      (advert) =>
        bannerTypes?.includes(advert.bannerType) &&
        advert.isBillPageAdvertEnabled,
    );
  }, [advertsData, bannerMessages]);

  return (
    <>
      {availableAdverts?.map((advert) => (
        <JointBillAdvert advert={advert} key={advert.id} />
      ))}
    </>
  );
};
